import { render } from "./widgetLoad.vue?vue&type=template&id=1b66ab1a"
import script from "./widgetLoad.vue?vue&type=script&lang=js"
export * from "./widgetLoad.vue?vue&type=script&lang=js"

import "./widgetLoad.vue?vue&type=style&index=0&id=1b66ab1a&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__